import script from "./SourceTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./SourceTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./SourceTooltip.vue?vue&type=style&index=0&id=328a6fba&lang=css"

const __exports__ = script;

export default __exports__